import { render, staticRenderFns } from "./PaymentsApproval.vue?vue&type=template&id=52e1a1af&scoped=true&"
import script from "./PaymentsApproval.vue?vue&type=script&lang=js&"
export * from "./PaymentsApproval.vue?vue&type=script&lang=js&"
import style0 from "./PaymentsApproval.vue?vue&type=style&index=0&id=52e1a1af&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e1a1af",
  null
  
)

export default component.exports